<label
  class="switch"
  [ngClass]="{
    'field-height': options.fieldHeight,
    wrapped: options.wrapped,
    'label-space': options.labelSpace
  }"
>
  <input type="checkbox" [checked]="options.active" />
  <span>{{ label }}</span>
</label>
